import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Twitter, Mail, Phone } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-navy text-white" data-id="element-529">
      <div className="container-custom py-12" data-id="element-530">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-531">
          {/* About */}
          <div data-id="element-532">
            <div className="mb-4" data-id="element-533">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/igtG848mur3MtJShm7pBsC/operation-launchpad-logo-white.png" alt="Operation Launchpad" className="h-12" data-id="element-534" />
            </div>
            <p className="mb-4 text-gray-300" data-id="element-535">
              Empowering aspiring entrepreneurs to launch and scale businesses
              to $1M+ annual revenue through proven systems and mentorship.
            </p>
            <div className="flex space-x-4" data-id="element-536">
              <SocialIcon icon={<Facebook size={20} data-id="element-538" />} href="https://facebook.com" data-id="element-537" />
              <SocialIcon icon={<Instagram size={20} data-id="element-540" />} href="https://instagram.com" data-id="element-539" />
              <SocialIcon icon={<Twitter size={20} data-id="element-542" />} href="https://twitter.com" data-id="element-541" />
              <SocialIcon icon={<Linkedin size={20} data-id="element-544" />} href="https://linkedin.com" data-id="element-543" />
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-545">
            <h3 className="text-xl font-bold mb-4 font-montserrat" data-id="element-546">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-547">
              <FooterLink to="/" data-id="element-548">Home</FooterLink>
              <FooterLink to="/about" data-id="element-549">About Us</FooterLink>
              <FooterLink to="/programs" data-id="element-550">Programs</FooterLink>
              <FooterLink to="/impact" data-id="element-551">Impact</FooterLink>
              <FooterLink to="/apply" data-id="element-552">Apply</FooterLink>
              <FooterLink to="/contact" data-id="element-553">Contact</FooterLink>
            </ul>
          </div>
          {/* Contact */}
          <div data-id="element-554">
            <h3 className="text-xl font-bold mb-4 font-montserrat" data-id="element-555">
              Contact Us
            </h3>
            <ul className="space-y-3" data-id="element-556">
              <li className="flex items-start space-x-3" data-id="element-557">
                <Mail size={20} className="mt-1 flex-shrink-0" data-id="element-558" />
                <span data-id="element-559">info@operationlaunchpad.org</span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-560">
                <Phone size={20} className="mt-1 flex-shrink-0" data-id="element-561" />
                <span data-id="element-562">(555) 123-4567</span>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-563">
            <h3 className="text-xl font-bold mb-4 font-montserrat" data-id="element-564">
              Stay Updated
            </h3>
            <p className="mb-4 text-gray-300" data-id="element-565">
              Subscribe to our newsletter for the latest news and updates.
            </p>
            <form className="flex flex-col space-y-2" data-id="element-566">
              <input type="email" placeholder="Your email address" className="px-4 py-2 rounded-md focus:outline-none text-navy" data-id="element-567" />
              <button type="submit" className="bg-gold hover:bg-amber-500 text-navy font-bold py-2 px-4 rounded-md transition duration-300" data-id="element-568">
                Subscribe
              </button>
            </form>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-569">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-570">
            © {new Date().getFullYear()} Operation Launchpad. All rights
            reserved.
          </p>
          <p className="text-gray-400 text-sm" data-id="element-571">
            In partnership with{' '}
            <a href="#" className="text-gold hover:underline" data-id="element-572">
              AETLAS
            </a>
          </p>
        </div>
      </div>
    </footer>;
};
const SocialIcon = ({
  icon,
  href
}) => {
  return <a href={href} target="_blank" rel="noopener noreferrer" className="bg-gray-700 p-2 rounded-full hover:bg-gold hover:text-navy transition duration-300" data-id="element-573">
      {icon}
    </a>;
};
const FooterLink = ({
  to,
  children
}) => {
  return <li data-id="element-574">
      <Link to={to} className="text-gray-300 hover:text-gold transition duration-300" data-id="element-575">
        {children}
      </Link>
    </li>;
};
export default Footer;